export default __webpack_public_path__ + "static/media/B&CMaterials.b744cc49.jpg";